<form [formGroup]="basisInfoForm" class="form">
  <ix-typography format="h3">Basics</ix-typography>
  <ix-layout-grid class="layout-grid-form" gap="12">
    <ix-row>
      <ix-col size="2" size-sm="12">
        <label class="tooltip-customer" aria-describedby="tooltip-customer">Customer</label>
        <ix-tooltip id="tooltip-customer" for=".tooltip-customer">{{
          basisInfoForm.controls[fields.CUSTOMER_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <ix-input type="text" [formControlName]="fields.CUSTOMER"></ix-input>
      </ix-col>
    </ix-row>
    <ix-row>
      <ix-col size="2" size-sm="12">
        <label class="tooltip-Country" aria-describedby="tooltip-Country">Country</label>
        <ix-tooltip id="tooltip-Country" for=".tooltip-Country">{{
          basisInfoForm.controls[fields.COUNTRY_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <ix-select class="ix-select input-width" name="ix-select-control" [formControlName]="fields.COUNTRY">
          @for (option of dropdowns[fields.COUNTRY]; track option) {
            <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
          }
        </ix-select>
      </ix-col>
    </ix-row>
    <ix-row>
      <ix-col size="2" size-sm="12">
        <label class="tooltip-location" aria-describedby="tooltip-location">Location</label>
        <ix-tooltip id="tooltip-location" for=".tooltip-location">{{
          basisInfoForm.controls[fields.LOCATION_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <ix-textarea [formControlName]="fields.LOCATION" textareaWidth="100%"></ix-textarea>
      </ix-col>
    </ix-row>
    <ix-row>
      <ix-col size="2" size-sm="12">
        <label class="tooltip-contactrc" aria-describedby="tooltip-contactrc">Contact RC</label>
        <ix-tooltip id="tooltip-contactrc" for=".tooltip-contactrc">{{
          basisInfoForm.controls[fields.CONTACT_RC_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <ix-textarea [formControlName]="fields.CONTACT_RC" textareaWidth="100%"></ix-textarea>
      </ix-col>
    </ix-row>
    <ix-row>
      <ix-col size="2" size-sm="12">
        <label class="tooltip-remarks" aria-describedby="tooltip-remarks">Remarks</label>
        <ix-tooltip id="tooltip-remarks" for=".tooltip-remarks">{{
          basisInfoForm.controls[fields.REMARKS_FIELD_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <ix-textarea [formControlName]="fields.REMARKS_FIELD" textareaWidth="100%"></ix-textarea>
      </ix-col>
    </ix-row>
    <ix-row>
      <ix-col size="2" size-sm="12">
        <label class="tooltip-simpleCalc" aria-describedby="tooltip-simpleCalc">Simple Calculation</label>
        <ix-tooltip id="tooltip-simpleCalc" for=".tooltip-simpleCalc">{{
          basisInfoForm.controls[fields.SIMPLE_CALC_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <ix-select
          class="ix-select input-width"
          name="ix-select-control"
          [formControlName]="fields.SIMPLE_CALC"
          (valueChange)="changeSimpleSelection()"
        >
          @for (option of dropdowns[fields.SIMPLE_CALC]; track option) {
            <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
          }
        </ix-select>
      </ix-col>
    </ix-row>

    @if (basisInfoForm.controls[fields.SIMPLE_CALC].value === 'MLFB') {
      <ix-row>
        <ix-col size="2" size-sm="12">
          <label class="tooltip-mlfb" aria-describedby="tooltip-mlfb">MLFB - Services</label>
          <!-- <ix-tooltip id="tooltip-mlfb" for=".tooltip-mlfb">{{basisInfoForm.controls['mlfbtooltiptext'].value}}</ix-tooltip>    -->
        </ix-col>
        <ix-col>
          <ix-select class="ix-select input-width" name="ix-select-control" [formControlName]="fields.MLFB_SELECTED">
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_1].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_1].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_2].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_2].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_3].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_3].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_4].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_4].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_5].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_5].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_6].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_6].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_7].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_7].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_8].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_8].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.MLFB_SHORT_9].value }}"
              value="{{ basisInfoForm.controls[fields.MLFB_9].value }}"
            ></ix-select-item>
          </ix-select>
        </ix-col>
      </ix-row>
    }

    @if (basisInfoForm.controls[fields.SIMPLE_CALC].value === 'Yes') {
      <ix-row>
        <ix-col size="2" size-sm="12">
          <label class="tooltip-services" aria-describedby="tooltip-services">Services</label>
          <ix-tooltip id="tooltip-services" for=".tooltip-services">{{
            basisInfoForm.controls[fields.SELECTION_TOOLTIP].value
          }}</ix-tooltip>
        </ix-col>
        <ix-col>
          <ix-select class="ix-select" name="ix-select-control" [formControlName]="fields.SELECTION">
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.SERVICE_TEXT_1].value }}"
              value="{{ dropdowns[fields.SELECTION][0].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.SERVICE_TEXT_2].value }}"
              value="{{ dropdowns[fields.SELECTION][1].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.SERVICE_TEXT_3].value }}"
              value="{{ dropdowns[fields.SELECTION][2].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.SERVICE_TEXT_4].value }}"
              value="{{ dropdowns[fields.SELECTION][3].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.SERVICE_TEXT_5].value }}"
              value="{{ dropdowns[fields.SELECTION][4].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.SERVICE_TEXT_6].value }}"
              value="{{ dropdowns[fields.SELECTION][5].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.SERVICE_TEXT_7].value }}"
              value="{{ dropdowns[fields.SELECTION][6].value }}"
            ></ix-select-item>
            <ix-select-item
              label="{{ basisInfoForm.controls[fields.SERVICE_TEXT_8].value }}"
              value="{{ dropdowns[fields.SELECTION][7].value }}"
            ></ix-select-item>
          </ix-select>
        </ix-col>
      </ix-row>
    }
    @if (
      basisInfoForm.controls[fields.SIMPLE_CALC].value === 'Yes' && basisInfoForm.controls[fields.SELECTION].value !== 1
    ) {
      <ix-row>
        <ix-col size="2" size-sm="12">
          <label class="tooltip-hosts" aria-describedby="tooltip-hosts">Hosts</label>
          <ix-tooltip id="tooltip-hosts" for=".tooltip-hosts">{{
            basisInfoForm.controls[fields.HOST_COUNT_TOOLTIP].value
          }}</ix-tooltip>
        </ix-col>
        <ix-col>
          <ix-number-input
            [formControlName]="fields.HOST_COUNT"
            pattern="[0-9]+"
            min="0"
            [invalidText]="validationFeedback.negativeInteger"
            showStepperButtons="true"
          ></ix-number-input>
        </ix-col>
      </ix-row>
    }
  </ix-layout-grid>

  <div class="button-container">
    <ix-button class="next-button" (click)="nextStep()">Next</ix-button>
  </div>
</form>
